// Per-route SEO overrides — keyword-rich titles (50-65 chars) and
// 150-160 char meta descriptions. Keyed by the CMS page `url` slug so we don't
// depend on (or need to migrate) the seo_title values stored in the database.

export const PAGE_SEO = {
  "Why-Choose-Lazy-Days-Home-Services": {
    title: "Why Choose Lazy Days — Arlington House Cleaning",
    description: "See why DFW families choose Lazy Days: English-speaking, background-checked maids, quality-checked cleaning, and the same trusted team at your home every visit.",
    keywords: "why choose lazy days, arlington cleaning service, english speaking maids dfw, background checked cleaners",
  },
  "Cleaning-Process": {
    title: "Our House Cleaning Process & Products — DFW TX",
    description: "Learn the Lazy Days cleaning process: fresh sanitized supplies per home, kitchen-first method, and trusted non-toxic products. Quality guaranteed across DFW.",
    keywords: "house cleaning process, non-toxic cleaning products, cleaning method arlington tx",
  },
  "Costs": {
    title: "House Cleaning Prices & Free Estimates — DFW TX",
    description: "Lazy Days house cleaning prices start at $50. Upkeep, deep-clean & move-out rates for Arlington, Mansfield & Fort Worth TX. Get a free in-home estimate today.",
    keywords: "house cleaning prices, cleaning cost arlington tx, free cleaning estimate dfw",
  },
  "Employment": {
    title: "House Cleaning Jobs in Arlington & DFW TX",
    description: "Join Lazy Days Home Services. House cleaning jobs in Arlington & DFW with above-average pay, no nights or weekends, plus paid drive time and supplies provided.",
    keywords: "cleaning jobs arlington tx, house cleaning employment dfw, maid jobs near me",
  },
  "Contact-Us": {
    title: "Contact Lazy Days — Free Cleaning Estimate DFW",
    description: "Contact Lazy Days Home Services for a free house cleaning estimate in Arlington, Mansfield & Fort Worth TX. Call (817) 277-7387 or send us a message today.",
    keywords: "contact cleaning service, free estimate arlington tx, house cleaning quote dfw",
  },
  "Gift-Certificate": {
    title: "House Cleaning Gift Certificates — DFW TX",
    description: "Give the gift of a beautifully clean home. Order Lazy Days house cleaning gift certificates for family & friends across Arlington and DFW. Call (817) 277-7387.",
    keywords: "cleaning gift certificate, house cleaning gift card dfw, gift idea arlington",
  },
  "Fun": {
    title: "Fun with Lazy Days — DFW House Cleaning",
    description: "See the fun side of Lazy Days Home Services — cleaning tips, behind-the-scenes posts and more from our Arlington & DFW house cleaning team. Follow us on Facebook!",
    keywords: "lazy days fun, house cleaning tips dfw, arlington cleaning team",
  },
  "housekeeping-service-areas": {
    title: "DFW House Cleaning Service Areas & Cities",
    description: "Lazy Days Home Services provides professional house cleaning across the DFW metroplex — Arlington, Fort Worth, Grand Prairie, Kennedale & Mansfield TX.",
    keywords: "dfw house cleaning, arlington cleaning service, mansfield maid service, service areas",
  },
};

export function getPageSeo(url) {
  return PAGE_SEO[url] || null;
}

// Build a BreadcrumbList JSON-LD object for a simple Home > Page trail.
export function breadcrumbSchema(name, path) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://lazydayshome.com/" },
      { "@type": "ListItem", "position": 2, "name": name, "item": `https://lazydayshome.com${path}` },
    ],
  };
}
